<template>
  <main class="form-signin w-100 m-auto">
    <div>
      <img
        class="mb-4 mt-5 mx-auto d-block"
        src="@/assets/KAI.png"
        alt=""
        width=""
        height="200"
        @click="goHome"
        role="button"
      />
      <h1 class="h3 mb-3 fw-normal text-center">Please sign in</h1>

      <div class="form-floating">
        <input
          type="email"
          class="form-control"
          id="floatingInput"
          placeholder="name@example.com"
          v-model.trim="user.email"
        />
        <label for="floatingInput">Email address</label>
      </div>
      <div class="form-floating">
        <input
          type="password"
          class="form-control"
          id="floatingPassword"
          placeholder="Password"
          v-model.trim="user.pw"
        />
        <label for="floatingPassword">Password</label>
      </div>

      <!-- <div class="checkbox mb-3">
        <label>
          <input type="checkbox" value="remember-me" /> Remember me
        </label>
      </div> -->
      <button class="w-100 btn btn-lg btn-primary mt-3" @click="login">
        Sign in
      </button>
      <p class="mt-5 mb-3 text-muted">&copy; KAI Certification Inc. 2023</p>
    </div>
  </main>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      user: {
        email: '',
        pw: '',
        name: ''
      }
    }
  },
  setup() {},
  created() {},
  mounted() {},
  unmounted() {},
  methods: {
    // 로그인 전에 가려던 곳으로 돌려보낸다. 라우터 가드가 ?redirect= 로 넘긴다.
    //
    // 메뉴가 없는 화면(세금계산서 승인)은 메일 링크가 유일한 입구라,
    // 이게 없으면 관리자가 링크를 누르고 로그인한 뒤 다시 메일로 돌아가
    // 링크를 한 번 더 눌러야 한다.
    //
    // 넘어온 값은 **저장소 안의 절대경로만** 허용한다. '//evil.com' 같은
    // 프로토콜 상대 URL 을 그대로 push 하면 외부로 튕겨나가는 통로가 된다.
    redirectTarget() {
      const raw = this.$route.query.redirect
      const target = Array.isArray(raw) ? raw[0] : raw
      if (typeof target === 'string' && /^\/(?!\/)/.test(target)) {
        return { path: target }
      }
      return { name: 'AuditSignalRampView' }
    },
    goHome() {
      this.$router.push({ path: '/' })
    },
    async login() {
      await this.$post('/login', {
        user: this.user
      })
        .then(
          (res) => {
            this.$swal(res.data.message)
            if (res.data.success === true) {
              this.$store.commit('user/setUser', {
                name: res.data.userData.user_name,
                email: res.data.userData.user_email,
                role: res.data.userData.user_role,
                id: res.data.userData.user_id,
                // pw: res.data.userData.user_pw,
                code: res.data.userData.user_auditable_code,
                yn: res.data.userData.user_yn,
                grade: res.data.userData.user_grade,
                ai_report_yn: res.data.userData.ai_report_yn
              })
              this.$router.push(this.redirectTarget())
            }
          },
          (err) => {
            console.log(err)
            this.$swal('로그인 실패')
          }
        )
        .catch((err) => {
          this.$swal(err)
        })
    }
  }
}
</script>
<style scoped>
html,
body {
  height: 100%;
}

body {
  display: flex;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #f5f5f5;
}

.form-signin {
  max-width: 330px;
  padding: 15px;
}

.form-signin .form-floating:focus-within {
  z-index: 2;
}

.form-signin input[type='email'] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.form-signin input[type='password'] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
